module.exports = __webpack_public_path__ + "img/like-icon-yellow.d1c68603.svg";